import { FI18n } from '@freelog/tools-lib';

export function isVerificationCodeInvalidResponse(
  data?: { errorType?: string } | null,
  msg?: string,
): boolean {
  return (
    data?.errorType === 'VerificationCodeInvalid' || msg === 'wrong_verified_code'
  );
}

/** bindFeed 等接口的验证码错误，需展示在验证码输入框下方（非顶部 toast） */
export function isVerificationCodeApiError(error: unknown): boolean {
  return (
    (error instanceof Error && error.name === 'VerificationCodeInvalid') ||
    (error instanceof Error && error.message === 'wrong_verified_code')
  );
}

export function createVerificationCodeError(): Error {
  const err = new Error(
    // 验证码错误
    FI18n.i18nNext.t('wrong_verified_code') as string,
  );
  err.name = 'VerificationCodeInvalid';
  return err;
}

/** bindRssFeed 失败时抛错：验证码错误带专用 name，其它错误仅带 msg（由 Flow 顶部 toast） */
export function throwBindRssFeedError(params: {
  ret: number;
  errCode: number;
  msg?: string;
  data?: { errorType?: string } | null;
}): void {
  const { ret, errCode, msg, data } = params;
  if (ret === 0 && errCode === 0) {
    return;
  }
  if (isVerificationCodeInvalidResponse(data, msg)) {
    throw createVerificationCodeError();
  }
  throw new Error(msg || '');
}
